angular.module('zc.zenclerkS')
  .controller('ZcsCampaignConfirmModalController', ZcsCampaignConfirmModalController);

ZcsCampaignConfirmModalController.$inject = ['$uibModalInstance'];
function ZcsCampaignConfirmModalController($uibModalInstance) {
  const vm = this;

  vm.createCampaign = createCampaign;
  vm.editCampaign = editCampaign;
  vm.close = close;

  function createCampaign() {
    $uibModalInstance.close('new');
  }

  function editCampaign() {
    $uibModalInstance.close('edit');
  }

  function close() {
    $uibModalInstance.close();
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/create_button/campaign_confirm_modal.controller.js